import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

// AppContext.js
const initialState = {
  currentStep: 1,
  totalPrice: 0,
  showConfetti: false, // ✅ Adicionar controle de confetti
  pricingConfig: {
    base: 0,  // ✅ Carregado do Firestore em AppCreation.js - não colocar valor fixo aqui
    logo: 0,
    loader: 0,
    platforms: 0,
    menu: 0,
    icons: 0
  },
  appData: {
    name: '',
    url: '',
    category: '', // ✅ DEIXE VAZIO INICIALMENTE
    logo: null,
    splash: null,
    loaderColor: '#3B82F6',
    platforms: [],
    hasMenu: false,
    menuColor: '#3B82F6',
    icons: [],
  },
  priceBreakdown: {
    base: 0,
    logo: 0,
    loader: 0,
    platforms: 0,
    menu: 0,
    icons: 0
  }
};

function appReducer(state, action) {
  switch (action.type) {
    case 'NEXT_STEP':
      return { ...state, currentStep: state.currentStep + 1 };
    case 'PREV_STEP':
      return { ...state, currentStep: state.currentStep - 1 };
    case 'SET_CONFETTI':
      return { ...state, showConfetti: action.payload };
    case 'SET_PRICING_CONFIG':
      return { ...state, pricingConfig: action.payload };
    case 'UPDATE_APP_DATA':
      return { ...state, appData: { ...state.appData, ...action.payload } };
    case 'UPDATE_PRICE':
      const newPriceBreakdown = { ...state.priceBreakdown, ...action.payload };
      const newTotalPrice = Object.values(newPriceBreakdown).reduce((sum, price) => sum + price, 0);

      return {
        ...state,
        priceBreakdown: newPriceBreakdown,
        totalPrice: newTotalPrice
      };
    case 'RESET_APP':
      return initialState;
    // No appReducer do AppContext.js:
    // No reducer, adicione também no RESET_APP_DATA:
    case 'RESET_APP_DATA':
      return {
        ...state, // preserva pricingConfig!
        currentStep: 1,
        showConfetti: false,
        appData: {
          name: '',
          url: '',
          category: 'general', // ✅ ADICIONAR AQUI TAMBÉM
          logo: null,
          splash: null,
          loaderColor: '#3B82F6',
          platforms: [],
          hasMenu: false,
          menuColor: '#3B82F6',
          icons: []
        },
        totalPrice: 0,
        priceBreakdown: {
          base: 0,
          logo: 0,
          loader: 0,
          platforms: 0,
          menu: 0,
          icons: 0
        }
      };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}